export default __webpack_public_path__ + "static/media/Club.aaa53d81.png";